import React from 'react';
import { LabelAndTooltipStyles as styles } from './FormFieldsV3InlineStyles';
import { TooltipIcon } from 'components/svgs/TooltipIcon.ts';
import { Popup } from 'semantic-ui-react';

interface ILabelAndTooltipProps {
  labelText?: string;
  tooltipText?: string;
}

const LabelAndTooltip = ({ labelText, tooltipText }: ILabelAndTooltipProps) => {
  if (!labelText && !tooltipText) {
    return null;
  }
  return (
    <div style={styles.labelAndTooltipContainer}>
      {labelText ? <div style={styles.label}>{labelText}</div> : null}
      {tooltipText ? (
        <Popup
          hideOnScroll={true}
          content={tooltipText}
          on="click"
          trigger={
            <div style={styles.tooltip}>
              <TooltipIcon />
            </div>
          }
        />
      ) : null}
    </div>
  );
};

export default LabelAndTooltip;
